<template>
    <div>
      <Pos_supplier/>
    </div>
  </template>
  
  <script>
  import Pos_supplier from "@/components/adminArin/pos_system/product/Pos_supplier";
  export default {
    name: "PosSupplier",
    components: {
      Pos_supplier
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  